exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".privacy .header-wrapper{justify-content:flex-start;height:64px}.header-wrapper .p-centre{font-size:14px;letter-spacing:.3px;color:#666;font-weight:500;margin-left:10px;line-height:1;padding-top:10px}@media (min-width:768px){.privacy .header-wrapper{height:72px;max-width:1024px;padding:10px 0}.privacy .header-wrapper #logo{margin-left:10px}.privacy .menu-hamburger{display:none}.header-wrapper .p-centre{font-size:24px;letter-spacing:.5px;padding-top:18px}}@media (min-width:1201px){.privacy .header-wrapper{max-width:1150px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/header/privacy-centre/header.scss
// module id = 889
// module chunks = 0